export const NavbarTabsData = [
    {
        title: "Dashboard",
        path: "/dashboard"
    },
    {
        title: "Associations",
        path: "/admin/associations"
    }
]